var map = {
	"./en/apple-store-badge.png": [
		639,
		0
	],
	"./en/google-play-badge.png": [
		640,
		1
	],
	"./fr/apple-store-badge.png": [
		1271,
		6
	],
	"./fr/google-play-badge.png": [
		1272,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1184;
module.exports = webpackAsyncContext;